import React from 'react';

const Copyright = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <div className="copyright-container">
      <div className="copyright-content">
        <p>© {currentYear} Siddharth KR. All rights reserved.</p>
        <p className="copyright-message">
          Weather data provided by Open-Meteo API. This application is for demonstration purposes only.
        </p>
      </div>
    </div>
  );
};

export default Copyright;